import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../../infrastructure/infrastructure.module';
import { Observable } from 'rxjs';
import { api } from '@bayclubs/utils'
import { camps } from '../../models/models.generated';

@Injectable()
export class SessionManagementApiService {

    constructor(private http: ApiHttpClient) { }


    public save(request: camps.SessionSaveRequest): Observable<api.OperationResultValue<camps.SessionDefinitionDetails>> {
        return this.http.post<api.OperationResultValue<camps.SessionDefinitionDetails>>(`session`, request, true);
    }

    public remove(request: camps.SessionRemoveRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`session/remove`, request, true);
    }

    public search(request: camps.AvailableSessionsSearchRequest): Observable<camps.SessionsResponse> {
        return this.http.post<camps.SessionsResponse>("session/search", request, true);
    }

    public shiftSession(request: camps.SessionMoveDaysRequest): Observable<api.OperationResult> {
        return this.http.post<api.OperationResult>(`session/move`, request, true);
    }
}
